import CartSubmit from './cartSubmit';

const CartSubmitUtils = { CartSubmit };

export default CartSubmitUtils;
